export default __webpack_public_path__ + "static/media/logo.bac55905.svg";